import { createFileRoute } from "@tanstack/react-router";
import TripsPage from "@/components/trips/trips-page";

function AdminTripsPage() {
  return (
    <TripsPage
      statuses={[]}
      defaultLayoutMode="split"
      detailsBasePath="/admin/trips"
    />
  );
}

export const Route = createFileRoute("/_app/admin/trips/")({
  component: AdminTripsPage,
});
